export const minimizeProductImage = (src: string) =>
  src.replace(
    '/image/upload/',
    '/image/upload/dpr_2.0,f_auto,q_auto,w_115,h_115,c_pad,d_photoiscoming.png/'
  );
